import type { ReactNode } from 'react';

interface StackedLayoutProps {
  children: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
}

export const StackedLayout = ({ children, footer, header }: StackedLayoutProps) => {
  return (
    <div className="grid grid-rows-[auto_1fr_auto] min-h-dvh">
      <div className={header === undefined ? 'pt-layout-sm md:pt-layout-md' : ''}>{header}</div>
      <div>{children}</div>
      <div>{footer}</div>
    </div>
  );
};
